import React from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import ConsentCheckbox from './ConsentCheckbox';

/**
 * Generic legal agreement checkboxes for any named flow.
 */
const FlowAgreementsSection = ({
  documents = [],
  checkedDocs = {},
  onCheckChange,
  onViewDocument,
  docsLoading = false,
  docsError = false,
  title = 'Required agreements',
  compact = false,
  children,
}) => (
  <Box
    sx={{
      p: compact ? 1.5 : 2,
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'grey.50',
    }}
  >
    <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1.5 }}>
      {title}
    </Typography>

    {docsLoading && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Loading legal documents…
      </Typography>
    )}

    {docsError && (
      <Typography variant="body2" color="error" sx={{ mb: 1 }}>
        Unable to load legal documents. Please refresh the page.
      </Typography>
    )}

    {!docsLoading && documents.length > 0 ? (
      documents.map((doc) => (
        <ConsentCheckbox
          key={doc.id}
          document={doc}
          checked={!!checkedDocs[doc.id]}
          onChange={onCheckChange}
          required
          onViewDocument={onViewDocument}
        />
      ))
    ) : !docsLoading ? (
      <FormControlLabel
        control={
          <Checkbox
            checked={!!checkedDocs.fallback}
            onChange={(e) => onCheckChange('fallback', e.target.checked)}
            color="primary"
          />
        }
        label={
          <Typography variant="body2">
            I have read and agree to the applicable terms.
          </Typography>
        }
        sx={{ mb: 1, alignItems: 'flex-start' }}
      />
    ) : null}

    {children}
  </Box>
);

export default FlowAgreementsSection;
